const welcomeContent = {
  thanks: 'Gracias [Nombre], cuestionario completado.',
  msg: 'Ahora agenda tu cita para que nuestros ortodoncistas puedan diseñar tu tratamiento'
}

export default welcomeContent
